// AUTO-GENERATED by scripts/gen-icons.mjs — do not edit by hand.
import Svg from '../svg/journal.svg?react';
import { Icon } from '../Icon';
import { IconProps } from '../types';

export const JournalIcon = (props: IconProps) => <Icon svg={Svg} {...props} />;
